import type { TCompany } from '@crm/entities/company';

export const getCompanyIdToActivate = ({ id, isActive }: TCompany) => (isActive ? null : id);

export const getCompanyTargetRoute = ({ access, routes }: TCompany) =>
    access.canUseCrm && routes.crm ? routes.crm : routes.construction;
